import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistsRoutingModule } from './checklists-routing.module';
import { ChecklistsComponent } from './checklists.component';
import { InformationModule } from '../../shared/modules/information.module';
import { RecordService } from '../../services/record.service';
import { FormService } from '../../services/form.service';
import { CreateChecklistComponent } from './create-checklist/create-checklist.component';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { SharedInputModule } from '../../shared/modules/shared-input.module';
import { ChecklistsService } from '../../services/checklist.service';
import { NgDragDropModule } from 'ng-drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ListingNewModule } from '../../shared/components/listing-new/listing-new.module';
import { ListingDialogModule } from '../../shared/components/listing-new/components/dialog/llisting-dialog.module';
import { EditModule } from '../../shared/modules/edit.module';
import { ChecklistsModule as SharedChecklistsModule } from '../../module/checklists/checklists.module';
import { ConvertPdfWithAiModule } from '../../shared/components/convert-pdf-with-ai/convert-pdf-with-ai.module';

@NgModule({
  declarations: [
    ChecklistsComponent,
    CreateChecklistComponent,
  ],
  imports: [
    ChecklistsRoutingModule,
    CommonModule,
    InformationModule,
    NgDragDropModule,
    DragDropModule,
    SharedModule.forRoot(),
    SharedInputModule,
    ListingNewModule,
    ListingDialogModule,
    EditModule,
    SharedChecklistsModule,
    ConvertPdfWithAiModule
  ],
  providers: [
    RecordService,
    FormService,
    ChecklistsService,
    TranslateService
  ],
})
export class ChecklistsModule { }
